'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import { identifyHubSpotUser } from '@workspace/ui/lib';
import { useEffect } from 'react';
import { useAuthStore } from '@/stores/authStore';

export function HubSpotIdentityBinding() {
  const user = useAuthStore((state) => state.user);
  const email = user?.user?.email ?? null;

  useEffect(() => {
    identifyHubSpotUser(email);
  }, [email]);

  return null;
}
